// extracted by mini-css-extract-plugin
module.exports = {"control":"styles_control__hBj5g","icon":"styles_icon__dVC4t"};